function trackClubPage() {
  const { analyticsEvent: event, analyticsClub: club } = document.body.dataset;
  if (!event || !club || !window.umami) return;
  window.umami.track(event, { club });
}

function trackFormSubmission(submitEvent) {
  if (!window.umami) return;
  if (submitEvent.detail?.success === false) return;

  const response = submitEvent.detail?.fetchResponse?.response;
  if (!response) return;

  const event = response.headers.get("X-Analytics-Event");
  if (!event) return;

  const properties = {};
  const club = response.headers.get("X-Analytics-Club");
  if (club) properties.club = club;

  const hasImages = response.headers.get("X-Analytics-Has-Images");
  if (hasImages !== null) properties.has_images = hasImages === "true";

  window.umami.track(event, properties);
}

document.addEventListener("turbo:load", trackClubPage);
document.addEventListener("turbo:submit-end", trackFormSubmission);
